import { PaymentActionType } from './actions';
import { efakturaInitialState, getInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case PaymentActionType.INIT_FORM:
            return getInitialState(action.payload.eFaktura);
        case PaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case PaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case PaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case PaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case PaymentActionType.PAYMENT_DATE:
            return {
                ...state,
                paymentDate: action.payload,
            };
        case PaymentActionType.SET_KID:
            return {
                ...state,
                kid: action.payload,
                note: '',
            };
        case PaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case PaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case PaymentActionType.RESET:
            return efakturaInitialState;
        case PaymentActionType.SET_EFAKTURA_ID:
            return {
                ...state,
                efakturaId: action.payload,
            };
        case PaymentActionType.SET_INITIAL_KID_AND_NOTE:
            return {
                ...state,
                hasInitialKid: !!action.payload.kid,
                kid: action.payload.kid,
                note: action.payload.note ?? '',
            };
        default:
            return state;
    }
};
const paymentReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cEfaktura form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default paymentReducer;
//# sourceMappingURL=data:application/json;base64,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